const my = {
    login: '/fy/app/shipperUser/signIn',
    authentication: '/fy/app/shipperUser/submitUserAuthContent',
    amount: '/fy/app/shipper/mine/getBanlance',
    tradeDetail: '/eas/fy/app/shipper/getAccountLogList',
    rechargeDetail: '/fy/app/shipper/mine/getRechargeRecordPage',
    bill: '/fy/app/shipper/mine/pageBills',
    smsCode: '/fy/app/shipper/order/sendPayOrderSms',
    pay: '/fy/app/shipper/order/payOrder',
    newpay: '/fy/app/shipper/order/pay/payOrder',
    truck: '/fy/app/shipper/mine/getFamiliarDriverList',
    truckSerach: '/fy/app/shipper/mine/getShipperDriverCarByPhone',
    truckAdd: '/fy/app/shipper/mine/addShipperDriverCar',
    truckDelete: '/fy/app/shipper/mine/deleteDriverCar',
    truckRegisterSms: '/fy/user/sendDriverInviteMsg',
    getUserAuthContent: '/fy/app/shipper/mine/getUserAuthContent',
    getAccountRechargeInfo: '/fy/app/shipper/mine/getAccountRechargeInfo',
    pageZeroBills: '/fy/app/shipper/mine/pageZeroBills',
    getDiscountMoney: '/fy/app/shipper/order/pay/getDiscountMoney',
    getPayAccount: '/fy/app/shipper/order/pay/getOrderPayAccount',
    getPayAccountWhole: '/eas/fy/app/getVehicleOrderPayAccount', // 整车账单支付
    xsAccount: '/eas/aws/account/get/material',
    xsAccountStatus: '/eas/aws/account/enterprise/get-status',
    quickOpen: 'eas/aws/account/enterprise/private/account/quick/open'
};

const picture = {
    upload: '/fy/oss/uploadFile'
};

const order = {
    list: '/eas/fcs/app/order/page-list',
    info: '/fy/app/shipper/order/getOrder',
    addOrderReceipt: '/fy/app/shipper/order/addOrderReceipt',
    getReceipt: '/fy/app/shipper/order/getReceipt',
    driverLoadgingOrder: '/fy/app/shipper/order/driverLoadgingOrder',
    driverFinishOrder: '/fy/app/shipper/order/driverFinishOrder',
    sign: '/fy/app/shipper/order/confirmReceiptApp',
    cancelOrder: '/fy/app/shipper/order/cancelOrder',
    getApplyPaymentData: '/fy/app/shipper/order/getApplyPaymentData',
    applyPayment: '/fy/app/shipper/order/applyPayment',
    applyPayDeposit: '/fy/app/shipper/order/applyPayDeposit',
    getPageList: '/fy/app/shipper/order/zeroLoad/getPageList',
    getByZeroLoadOrderNumber: '/fy/app/shipper/order/zeroLoad/getByZeroLoadOrderNumber',
    zerocancelOrder: '/fy/app/shipper/order/zeroLoad/cancelOrder',
    zeroGetApplyPaymentData: '/fy/app/shipper/order/zeroLoad/getApplyPaymentData',
    zeroGetApplyPayment: '/fy/app/shipper/order/zeroLoad/applyPayment',
    getLoadAndFinishTime: '/fy/appDriver/getLoadAndFinishTime',
    driverLoadingOrderByLocation: '/fy/appDriver/driverLoadingOrderByLocation',
    getContractUrl: '/fy/app/contract/getContractUrl',
    updateControlGoodsState: '/fy/app/shipper/order/zeroLoad/updateControlGoodsState',
    getAppraiseInfo: '/fy/app/shipper/order/getAppraiseInfo', // 获取订单评价基础数据
    addAppraise: '/fy/app/shipper/order/addAppraise', // 评价订单
    getOrderAppraise: '/fy/app/shipper/order/getOrderAppraise', // 获取订单评价数据 查看评价
    getOtherOrganCount: '/fy/app/shipper/order/pay/getOtherOrganCount', // 获取当前组织其他订单
    getCancelOrderTips: '/fy/order/zeroLoad/getCancelOrderTips',
    selfSendCar: '/fy/app/shipper/order/zeroLoad/selfSendCar',
    queryPolicy: '/eas/fy/dragon/insure/policy/query',
    checkLoadOrder: '/eas/fcs/app/order/order-load-check', // 货主确认发车校验
    appealOrder: '/eas/fcs/app/order/get-appeal-order', // 订单申诉详情
    submitOrder: '/eas/fcs/app/order/sumbit-appeal-order', // 订单提交申诉
    repealOrder: '/eas/fcs/app/order/cancel-appeal-order', // 订单撤销申诉
    depositMaxTime: '/eas/fos/app/cargo-source/deposit/max-time', // 押金协议最长时间
    arrivalsConfirmInfo: '/eas/fcs/app/order/check-car-driver', // 是否加载到达页面
    modifyCheck: '/eas/fcs/app/order/zeroLoad/shipper/modifyOrderAudit', // 改单审核
    modifyDetail: '/eas/oms/apply/app/shipper/modify-apply/info', // 改单详情
    itemBulkPage: '/dps/fos/driver/cargo-source/item/bulk/page', // 根据项目查询大宗货源列表
    itemGrabPage: '/dps/fos/driver/cargo-source/item/grab/page', // 根据项目查询大宗货源列表
    itemToDistance: '/dps/fos/driver/cargo-source/to/distance', // 批量查询到货源距离
    itemSourceInfo: '/dps/fy/driver/get/source/info', // 项目货源码项目信息
    contractDetail: '/eas/agency/contract/detail', // 代发协议详情
    sendSms: '/eas/agency/contract/sms/send', // 代发合同发送短信
    contractSigned: '/eas/agency/contract/signed' // 代发合同签订
};

const activity = {
    commissionCenter: '/fy/app/activity/commissionCenter', // 暂时不用了
    getActivityUser: '/fy/app/activity/getActivityUser',
    getCurLoginUserInfo: '/fy/app/activity/getCurLoginUserInfo',
    quickRegisterActivityUser: '/fy/app/activity/quickRegisterActivityUser',
    listInviteIncomeRecords: '/fy/app/activity/listInviteIncomeRecords',
    listInviteRecords: '/fy/app/activity/listInviteRecords',
    inviteRecord: '/fy/app/activity/mainPage/inviteRecord',
    listIncomeRecords: '/fy/app/activity/listIncomeRecords',
    getBrokerageFeeTypeList: '/fy/app/activity/getBrokerageFeeTypeList',
    submitCrash: '/fy/app/activity/crashPage/submitCrash',
    getCash: '/fy/app/activity/crashPage',
    getActivityInfo: '/fy/app/activity/getActivityInfo',
    myIncome: '/fy/app/activity/mainPage/myIncome',
    crashRecord: '/fy/app/activity/mainPage/myIncome/crashRecord',
    incomeRecord: '/fy/app/activity/mainPage/myIncome/incomeRecord',
    mainPage: '/fy/app/activity/mainPage', // 活动首页主接口
    incomeRecordMock: '/dps/fy/activity/invite/income-record', // 随机获取返佣数据
    activityCenter: '/dps/mkt/dashboard', // 活动中心
    redpInfo: '/dps/mkt/chb/dashboard', // 拆红包信息
    openRedp: '/dps/mkt/chb', // 拆红包
    available: '/dps/mkt/balance/available', // 司机app查询余额
    availableSubmit: '/dps/mkt/withdraw/submit/all' // 司机app 发起提现
};

const price = {
    getPriceList: '/fy/app/shipper/order/zeroLoad/getPriceList', // 获取从深圳出发的线路省份统计信息 获取报价列表
    getPriceListByToProvince: '/fy/app/shipper/order/zeroLoad/getPriceListByToProvince', // 获取从深圳出发的线路市区统计信息
    // getCitys: '/fy/app/shipper/order/zeroLoad/getCitys', // 获取下级城市接口 不要了
    getCitys: '/eas/add/district', // 根据父节点ID查询下级地区 最新的
    pickUpList: '/eas/zlo/price/list/pickUp', // 查询分拨列表
    areaList: '/eas/zlo/price/list/area', // 查询区县价目表
    provinceList: '/eas/zlo/price/list/province', // 查询省级价目表
    getPickUpList: '/fy/app/shipper/order/zeroLoad/getPickUpList', // 获取分拨区域列表
    addressSearch: 'eas/add/ext/highlight-search', // 地址高亮查询
    addressSearchDps: 'dps/add/ext/highlight-search', // 地址高亮查询
    getOrderZeroLoadLogistics: '/eas/fy/order/zeroLoad/getOrderZeroLoadLogistics' // 获取零担物流轨迹信息  短信链接点击进去
};

const finance = {
    xs: {
        apply: '/eas/fsc/financial/shipper/credit/apply', // 锡望贷授信申请
        use: '/eas/fsc/financial/shipper/use/credit/apply', // 锡望贷用信
        refund: '/eas/fsc/financial/acquire/repayment/address', // 锡望贷还款
        query: '/eas/fsc/financial/use_info/query' // 锡望贷查询
    }
};

const share = {
    line: '/dps/mas/demand/detail/h5', // 线路详情
    driver: '/dps/fcs/driver/get-driver-homepage', // 司机信息
    wxcofig: '/fy/weixin/createJsapiSignatureTianjin' // weixin config
};

const contract = {
    signRem: '/eas/fcs/contract/flexible-agent/sign-recommendation-letter', // 签订合同-运力经纪人推荐函
    signAgreement: '/dps/fcs/contract/flexible-agent/sign-cooperation-agreement', // 签订合同-运力经纪人推荐函
    networkFreightQuery: '/eas/fcs/contract/network-freight/query', // 网货合同查询
    networkFreightPushSms: '/eas/fcs/contract/network-freight/push/sms', // 网货合同发送验证码
    networkFreightPushPromiseLetterSms: '/eas/fcs/contract/network-freight/push/promise-letter/sms', // 网货合同承诺书发送验证码
    networkFreightSignPromiseLetter: '/eas/fcs/contract/network-freight/sign/promise-letter', // 网货合同签署承诺书
    networkFreightSign: '/eas/fcs/contract/network-freight/sign' // 网货合同签署
};

// 运单轨迹分享
const track = {
    getShareUserInfo: '/eas/order/track-link/get-share-user-info', // 获取分享公司和用户信息
    getShareOrderInfo: '/eas/order/track-link/get-share-order-list', // 获取分享链接的订单列表
    getShareOrderTrack: '/eas/order/track-link/get-share-order-track', // 获取分享链接的订单轨迹详情
    checkSharePwd: '/eas/order/track-link/check-share-pwd' // 校验密码
};

// 文档中心
const doc = {
    content: (fileName) => `/ias/document-center/content/get/${fileName}`
};

// 红包活动
const redPacket = {
    isBind: '/eas/fus/app/user/wx-bind-state', // 是否绑定微信
    showList: '/eas/css/app/red-packet/simple-list' // 跑马灯列表
};

const insure = {
    info: '/dps/driver-fee/get-insurance-premium-info', // 获取保险信息
    price: '/dps/driver-fee/calculate-insurance-premium-fee', // 获取保险价格
    tip: '/dps/driver-fee/get-insurance-premium-notes', // 获取保险须知
    accident: {
        info: '/dps/fcs/driver-insurance/get-by-business-no', // 获取保险信息
        buy: '/dps/fcs/driver-insurance/create' // 购买保险
    }
};

const base = {
    config: '/dps/cfg/get'
};

export default {
    my,
    picture,
    order,
    activity,
    price,
    finance,
    share,
    contract,
    track,
    doc,
    redPacket,
    insure,
    base
};



// WEBPACK FOOTER //
// ./src/config/api.js